if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.MS_IN_SEC = 1000;
        this.MS_IN_MIN = 60 * this.MS_IN_SEC;
        this.MS_IN_HRS = 60 * this.MS_IN_MIN;
        this.MS_IN_DAY = 24 * this.MS_IN_HRS;

        this.shouldAddLeadingZero = true;
        this.type = this.dataset.type;
        this.initCountdown();
      }

      initCountdown() {
        switch (this.type) {
          case 'fixed_time':
            const countdownData = this.dataset.dueDate;
            if (countdownData) {
              this.targetTime = new Date(countdownData).getTime();
            }
            break;
          default: // Evergreen.
            this.targetTime = this.getEvergreenDueDate().getTime();
            break;
        }

        if (!this.targetTime) return;

        this.startTime = Date.now();
        if (this.targetTime > this.startTime) {
          this.beginCountdown();
        }
      }

      beginCountdown() {
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();
          if (remainingTime <= 0) {
            this.terminateCountdown();
          } else {
            this.updateDisplay(remainingTime);
          }
        }, 1000);
        this.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const days = Math.floor(remainingTime / this.MS_IN_DAY);
        const hours = Math.floor((remainingTime % this.MS_IN_DAY) / this.MS_IN_HRS);
        const minutes = Math.floor((remainingTime % this.MS_IN_HRS) / this.MS_IN_MIN);

        const h = this.shouldAddLeadingZero && hours < 10 ? `0${hours}` : hours;
        const m = this.shouldAddLeadingZero && minutes < 10 ? `0${minutes}` : minutes;
        const d = days > 0 ? `${days} ${days === 1 ? 'day' : 'days'} ` : '';

        this.innerHTML = `📦 To receive your order from as quick as the <strong>next working day</strong> 🚚 Order within the next<span class="purpletext"> ${d}${h} hrs ${m} mins</span> ⏰`;
      }

      terminateCountdown() {
        clearInterval(this.intervalId);
        this.targetTime = this.getEvergreenDueDate().getTime();
        this.beginCountdown();
      }

      // REVERTED 15 September 2026. The free Priority upgrade promotion has
      // ended, so this is back to the despatch message and a 12:00 midday
      // cut-off, matching Fast Printed Packaging. It previously read
      // "Order today and you could unlock a free delivery upgrade at checkout"
      // and counted to the 5pm offer deadline.
      //
      // OPEN QUESTION flagged to Corey 15 Sep 2026: Parcelsend is not the same
      // as the printed-only stores. Its UNPRINTED range has a genuine Next
      // Working Day service with a 3:00pm cut-off, while printed orders use a
      // 12:00 midday cut-off from final proof approval. This message says
      // "next working day", which is the unprinted service, so 15:00 may be
      // the more accurate target here. Change the two 12 values below to 15
      // if so.
      //
      // Kept from the promotion build because they were bug fixes, not
      // promotion features: weekend skipping, restart-on-expiry instead of
      // freezing at 00 hrs 00 mins, and the days prefix that the weekend skip
      // requires.
      isWorkingDay(date) {
        const day = date.getDay();
        return day >= 1 && day <= 5;
      }

      getEvergreenDueDate() {
        const now = new Date();
        const dueDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0);
        while (dueDate.getTime() <= now.getTime() || !this.isWorkingDay(dueDate)) {
          dueDate.setDate(dueDate.getDate() + 1);
          dueDate.setHours(12, 0, 0, 0);
        }
        return dueDate;
      }
    }
  );
}
